import {ActionReducerMapBuilder, createReducer, PayloadAction} from "@reduxjs/toolkit";
import {GroupObject} from "../../../../vkapi/objects/GroupObject";
import AddDefaultCasesToReducer from "../../../helpers/AddDefaultCasesToReducer";
import DefaultStateProps from "../../../helpers/DefaultStateProps";
import {DefaultProps, TaskProgress} from "../../types";
import * as actions from './actions';
import * as types from "./types";
import {InstagramResult, InstagramSearchType, SiteType} from "./types";

const initialState: types.InstagramState = {
    settings: {
        search_type: InstagramSearchType.BY_GROUPS,
        source_groups: '',
        source_users: '',
        site_type: SiteType.INSTAGRAM
    },
    skipped: [],
    sub_progress: {message: ''},
    ...DefaultStateProps<InstagramResult>({site_urls: [], user_ids: []})
};

const InstagramReducer = createReducer(initialState, builder => {
    builder.addCase(actions.setSearchType, (state, action: PayloadAction<InstagramSearchType>) => {
        state.settings.search_type = action.payload;
    });
    builder.addCase(actions.setSourceGroups, (state, action: PayloadAction<string>) => {
        state.settings.source_groups = action.payload;
    });
    builder.addCase(actions.setSourceUsers, (state, action: PayloadAction<string>) => {
        state.settings.source_users = action.payload;
    });
    builder.addCase(actions.setSiteType, (state, action: PayloadAction<SiteType>) => {
        state.settings.site_type = action.payload;
    });
    builder.addCase(actions.setSkipped, (state, action: PayloadAction<GroupObject[]>) => {
        state.skipped = action.payload;
    });
    builder.addCase(actions.setSubProgress, (state, action: PayloadAction<TaskProgress>) => {
        state.sub_progress = action.payload;
    });

    AddDefaultCasesToReducer<InstagramResult>({
        actions: {
            setTaskStatus: actions.setTaskStatus,
            setProgress: actions.setProgress,
            setResult: actions.setResult,
            addApiError: actions.addApiError,
            resetApiErrors: actions.resetApiErrors
        }
    }, builder as unknown as ActionReducerMapBuilder<DefaultProps<InstagramResult>>);
});

export default InstagramReducer;
